import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { setSbpGateHandler } from '../services/api';
import { SBPModal } from './SBPModal';

/**
 * Top-level gate that listens for 412 `user_unverified` API responses and
 * surfaces the shared `SBPModal`. Navigating to `/sbp-linking` is delegated
 * to the modal itself; from there the user links their phone — the backend
 * either matches an existing `users` row by phone or creates a new one —
 * without granting any reward NFT (that's the White List / ClaimReward flow).
 *
 * Must be mounted once, inside BrowserRouter and below the main app shell.
 */
export const SbpGate: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const onSbpRoute =
    location.pathname.startsWith('/sbp-linking') ||
    location.pathname.startsWith('/auth');

  useEffect(() => {
    setSbpGateHandler(() => {
      // Don't surface the modal when the user is already on the linking page
      // (otherwise their own 412s would re-open it on top of the form).
      if (
        window.location.pathname.startsWith('/sbp-linking') ||
        window.location.pathname.startsWith('/auth')
      ) {
        return;
      }
      setIsOpen(true);
    });
    return () => {
      setSbpGateHandler(null);
    };
  }, []);

  // Close if the user navigates into the linking page while the modal is up.
  useEffect(() => {
    if (onSbpRoute && isOpen) {
      setIsOpen(false);
    }
  }, [onSbpRoute, isOpen]);

  return (
    <SBPModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    />
  );
};
